import { useParams } from 'react-router-dom';

export const useBusinessParams = () => {
  const { businessId, outletId, tableId } = useParams<{
    businessId: string;
    outletId?: string;
    tableId?: string;
  }>();

  return {
    businessId,
    outletId,
    tableId,
  };
};
